import Api from '../services/api'
import { COURSE } from '../services/constants'

export default {
  data() {
    return {
      selectedCourseType: COURSE.SHORT_TERM, // DB:Short Term
      selectedCourseGroup: 0,
      selectedCourse: 0,
      courseGroups: [],
      courseTypes: [],
      courses: [],
    };
  },
  methods: {
    getCourses(resetSelected, disableAll) {
      if(resetSelected) { this.selectedCourse = 0; }
      if(this.selectedCourseType != null) {
        Api.course.getAllFromType(this.selectedCourseType)
          .then((response) => {
            this.courses = response.data;
            if(!disableAll) {
              this.courses.unshift({
                id: 0,
                title: 'All'
              });
            }
            if(this.refresh) { this.refresh(); }
          })
          .catch(() => { this.courses = []; });
      }
    },

    getCourseGroups(courseId) {
      let promise = new Promise((resolve) => {
        if(courseId) {
          Api.course.getGroups(courseId)
            .then((response) => {
              this.courseGroups = response.data;
              this.courseGroups.unshift({
                id: 0,
                title: 'Ungrouped'
              });
            })
            .catch(() => { this.courseGroups = []; })
            .finally(() => { resolve(); })
        } else {
          resolve();
        }
      });

      return promise;
    },
    
    getCourseTypes() {
      Api.course.getAllTypes()
        .then((response) => {
          this.courseTypes = response.data;
        });
    }
  }
}